<template>
  <div>
    <vue-element-loading :active="appLoading" :is-full-screen="true" />
    <v-snackbar v-model="showsnackbar" color="red" right :timeout="timeout">
      <v-layout wrap justify-center>
        <v-flex text-left class="align-self-center">{{msg}}</v-flex>
        <v-flex text-right>
          <v-btn small :ripple="false" text @click="showsnackbar = false">
            <v-icon style="color:white;">mdi-close</v-icon>
          </v-btn>
        </v-flex>
      </v-layout>
    </v-snackbar>
    <v-layout wrap justify-center>
      <v-flex px-2 xs12 sm12 md12 lg12 xl12 text-center>
        <v-form ref="form" v-model="valid" lazy-validation>
          <v-layout wrap>
            <v-flex xs12 pt-2>
              <v-card class="mb-1">
                <v-card-title
                  >Seller Details
                  <v-spacer></v-spacer>
                  <v-flex xs8 text-right>
                    <router-link
                      style="text-decoration: none; color: black"
                      :to="'/sellerOffer?seller=' + seller._id"
                    >
                      <v-btn outlined color="blue"> Add Offer </v-btn>
                    </router-link>
                  </v-flex>
                  <v-flex text-right>
                    <router-link
                      style="text-decoration: none; color: black"
                      :to="'/sellerEdit?seller=' + seller._id"
                    >
                      <v-btn color="red" outlined>Edit Profile</v-btn>
                    </router-link>
                  </v-flex>
                </v-card-title>
              </v-card>
              <v-card class="mb-1 pb-8" min-height="32em">
                <v-img
                  v-if="coverphoto"
                  class="pa-6"
                  :src="baseURL + '/file/get/' + coverphoto"
                  height="250px"
                >
                  <template v-slot:placeholder>
                    <v-row
                      class="fill-height ma-0"
                      align="center"
                      justify="center"
                    >
                      <v-progress-circular
                        indeterminate
                        color="#0066ff"
                      ></v-progress-circular>
                    </v-row>
                  </template>
                  <v-row class="py-2">
                    <v-col cols="12" class="pa-15 text-left">
                      <v-avatar
                        style="cursor: pointer"
                        v-if="profilepic"
                        size="150"
                      >
                        <img
                          style="object-fit: cover"
                          :src="baseURL + '/file/get/' + profilepic"
                        />
                      </v-avatar>
                    </v-col>
                  </v-row>
                </v-img>

                <v-tabs
                  v-model="datatab"
                  background-color="white"
                  color="primary"
                  grow
                >
                  <v-tab> Profile Details </v-tab>

                  <v-tab> Bank Details </v-tab>
                  <v-tab> Product Details </v-tab>
                  <v-tab> Products Sold</v-tab>
                  <v-tab-item>
                    <v-card color="basil" flat>
                      <v-card-text
                        ><v-row>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Shop Name</span>
                              </v-col>
                              <v-col cols="7">
                                <span
                                  v-if="seller.sellerid"
                                  class="item_value ma-2"
                                  >{{ seller.sellerid.shopName }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="4" md="5" class="text-left">
                                <span class="item_title">Email</span>
                              </v-col>
                              <v-col cols="8" md="7">
                                <span
                                  v-if="seller.sellerid"
                                  class="item_value ma-2"
                                  >{{ seller.sellerid.email }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Phone</span>
                              </v-col>
                              <v-col cols="7">
                                <span class="item_value ma-2">{{
                                  seller.phone
                                }}</span>
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="4" md="5" class="text-left">
                                <span class="item_title">Contact Person</span>
                              </v-col>
                              <v-col cols="8" md="7">
                                <span
                                  v-if="seller.sellerid"
                                  class="item_value ma-2"
                                  >{{ seller.sellerid.contactPerson }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="4" md="5" class="text-left">
                                <span class="item_title">City</span>
                              </v-col>
                              <v-col cols="8" md="7">
                                <span
                                  v-if="seller.sellerid"
                                  class="item_value ma-2"
                                  >{{ seller.sellerid.city }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="4" md="5" class="text-left">
                                <span class="item_title">Place</span>
                              </v-col>
                              <v-col cols="8" md="7">
                                <span
                                  v-if="seller.sellerid"
                                  class="item_value ma-2"
                                  >{{ seller.sellerid.place }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Pincode</span>
                              </v-col>
                              <v-col cols="7">
                                <span
                                  v-if="seller.sellerid"
                                  class="item_value ma-2"
                                  >{{ seller.sellerid.pincode }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Seller Status</span>
                              </v-col>
                              <v-col cols="7">
                                <span
                                  v-if="seller.status == 'active'"
                                  class="item_value ma-2"
                                >
                                  Active
                                </span>
                                <span
                                  v-else-if="seller.status == 'pending'"
                                  class="item_value ma-2"
                                >
                                  Pending
                                </span>
                                <span v-else class="item_value ma-2">
                                  Incomplete
                                </span>
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>

                          <v-col cols="12" md="4">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Account Created</span>
                              </v-col>
                              <v-col cols="7">
                                <span class="item_value ma-2"
                                  >{{ formatDate(seller.create_date) }}
                                </span>
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col cols="4" class="text-left">
                                <span class="item_title">Category</span>
                              </v-col>
                              <v-col cols="8" class="text-left">
                                <v-chip
                                  v-for="(item, i) in category"
                                  :key="i"
                                  style="font-size: 14px; margin-right: 3px"
                                >
                                  {{ item.name }} </v-chip
                                >&nbsp;
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col cols="4" class="text-left">
                                <span class="item_title">Sub Category</span>
                              </v-col>
                              <v-col cols="8" class="text-left">
                                <v-chip
                                  v-for="(item, i) in subcategory"
                                  :key="i"
                                  style="font-size: 14px; margin-right: 3px"
                                >
                                  {{ item.name }}
                                </v-chip>
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col cols="4" class="text-left">
                                <span class="item_title">Documents</span>
                              </v-col>
                              <v-col cols="8" class="text-left">
                                <v-row wrap justify-center>
                                  <v-col
                                    cols="2"
                                    v-for="(item, i) in docs"
                                    :key="i"
                                  >
                                    <a
                                      target="_blank"
                                      :href="baseURL + '/file/get/' + item"
                                    >
                                      <!-- <v-card flat tile> -->

                                      <v-img src="./pdf.png" contain></v-img>
                                      <!-- </v-card> -->
                                    </a>
                                  </v-col>
                                  <v-col cols="2">
                                    <div v-viewer style="display: flex">
                                      <div
                                        v-for="(image, i) in photos"
                                        :key="i"
                                      >
                                        <img
                                          :src="baseURL + '/file/get/' + image"
                                          class="image"
                                          style="
                                            width: 100%;
                                            height: 100%;
                                            object-fit: cover;
                                            max-width: 250px;
                                          "
                                          :key="image.src"
                                        />
                                      </div>
                                    </div>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col cols="4" class="text-left">
                                <span class="item_title">Working Hours</span>
                              </v-col>
                              <v-col cols="8" class="text-left">
                                <v-row
                                  v-for="(item, i) in workingHours"
                                  :key="i"
                                  style="font-size: 14px"
                                >
                                  <v-col cols="4" class="text-left">
                                    <span
                                      v-if="item.working == false"
                                      style="color: red"
                                    >
                                      {{ item.day }}
                                    </span>
                                    <span v-else style="color: black">
                                      {{ item.day }}
                                    </span>
                                  </v-col>
                                  <v-col cols="4" class="text-left">
                                    <span>
                                      {{ item.open }} - {{ item.close }}
                                    </span>
                                  </v-col>
                                </v-row>
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="12">
                            <v-row>
                              <v-col class="text-left">
                                <span class="item_title">Location</span>
                              </v-col>
                              <v-flex xs12 py-2 pa-sm-2>
                                <Map
                                  :key="seller._id"
                                  v-bind:storage="seller.sellerid"
                                />
                              </v-flex>
                            </v-row>
                            <hr />
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-card color="basil" flat>
                      <v-card-text>
                        <v-row>
                          <v-col cols="12" md="6">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Account Holder</span>
                              </v-col>
                              <v-col cols="7">
                                <span
                                  v-if="seller.sellerid.bankDetails"
                                  class="item_value ma-2"
                                  >{{
                                    seller.sellerid.bankDetails.accountHolder
                                  }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Account Number</span>
                              </v-col>
                              <v-col cols="7">
                                <span
                                  v-if="seller.sellerid.bankDetails"
                                  class="item_value ma-2"
                                  >{{
                                    seller.sellerid.bankDetails.accountNo
                                  }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Bank Name</span>
                              </v-col>
                              <v-col cols="7">
                                <span
                                  v-if="seller.sellerid.bankDetails"
                                  class="item_value ma-2"
                                  >{{ seller.sellerid.bankDetails.bank }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <v-col cols="12" md="6">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">Branch</span>
                              </v-col>
                              <v-col cols="7">
                                <span
                                  v-if="seller.sellerid.bankDetails"
                                  class="item_value ma-2"
                                  >{{
                                    seller.sellerid.bankDetails.branch
                                  }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col>
                          <!-- <v-col cols="12" md="6">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">GST Id</span>
                              </v-col>
                              <v-col cols="7">
                              <span v-if="seller.sellerid.bankDetails" class="item_value ma-2">{{
                                 seller.sellerid.bankDetails.gst
                                }}</span>
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col> -->
                          <v-col cols="12" md="6">
                            <v-row>
                              <v-col cols="5" class="text-left">
                                <span class="item_title">IFSC Code</span>
                              </v-col>
                              <v-col cols="7">
                                <span
                                  v-if="seller.sellerid.bankDetails"
                                  class="item_value ma-2"
                                  >{{ seller.sellerid.bankDetails.ifsc }}</span
                                >
                              </v-col>
                            </v-row>
                            <hr />
                          </v-col> </v-row
                      ></v-card-text>
                    </v-card>
                  </v-tab-item>

                  <v-tab-item>
                    <v-layout v-if="products.length > 0" wrap>
                      <v-flex v-for="(item, i) in products" :key="i" md3 pa-4>
                        <v-card router-link :to="'/productDetails/' + item._id">
                          <v-img
                            v-if="item.photos.length == 0"
                            src="../../assets/user-info.jpg"
                            contain
                          ></v-img>
                          <v-img
                            v-else
                            :src="baseURL + '/file/get/' + item.photos[0]"
                            height="150px"
                          >
                          </v-img>

                          <v-card-text class="text-left">
                            <span style="font-size: 13px; color: #000000">
                              {{ item.name }}
                            </span>
                            <br />
                            <span
                              v-if="item.discount > 0"
                              style="font-size: 13px; color: #000000"
                            >
                              Rs. {{ item.price * (1 - item.discount / 100) }}
                            </span>
                            <span
                              v-else
                              style="font-size: 13px; color: #000000"
                            >
                              Rs. {{ item.price }}
                            </span>
                            <span
                              class="pl-2 text-decoration-line-through"
                              style="font-size: 13px"
                              v-if="item.discount > 0"
                            >
                              <strike> Rs. {{ item.price }} </strike>
                            </span>

                            <span
                              class="pl-2 text-decoration-line-through"
                              style="font-size: 13px; color: #3bc17a"
                              v-if="item.discount > 0"
                            >
                              {{ item.discount }}% Off
                            </span>
                            <br />
                            <span>
                              <v-rating
                                v-model="item.rating"
                                color="#FFD341"
                                background-color="#e0e0e0"
                                empty-icon="$ratingFull"
                                half-increments
                                readonly
                                hover
                                small
                              ></v-rating>
                            </span>
                          </v-card-text>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap v-else justify-center pt-10>
                      <v-flex md4>
                        <h1>Oops!! No data found</h1>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap justify-end>
                      <v-flex md2 v-if="products.length >= 8">
                        <v-btn text small @click="productinfo(seller._id)"
                          >view more
                        </v-btn>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>

                  <v-tab-item>
                    <v-layout wrap justify-start v-if="products.length > 0">
                      <v-flex
                        xs6
                        px-2
                        py-2
                        v-for="(item, i) in productsold"
                        :key="i"
                      >
                        <v-card
                          flat
                          rounded="xl"
                          color="#F5F7FC"
                          outlined
                          :to="'/Purchase/' + item.order_id"
                        >
                          <v-layout px-sm-4 pb-1 wrap justify-center>
                            <v-flex xs12>
                              <v-layout wrap justify-center>
                                <v-flex xs3 lg3 xl3 pa-2>
                                  <v-img
                                    :src="
                                      baseURL +
                                      '/file/get/' +
                                      item.productId.photos[0]
                                    "
                                    height="100px"
                                    contain
                                  >
                                    <template v-slot:placeholder>
                                      <v-row
                                        class="fill-height ma-0"
                                        align="center"
                                        justify="center"
                                      >
                                        <v-progress-circular
                                          indeterminate
                                          color="#FF4343"
                                        ></v-progress-circular>
                                      </v-row>
                                    </template>
                                  </v-img>
                                </v-flex>
                                <v-flex xs9 lg9 xl9 style="line-height: 20px">
                                  <v-layout wrap justify-center>
                                    <v-flex xs12 text-left pt-2>
                                      <span
                                        style="font-size: 16px; color: #808080"
                                      >
                                        <b> {{ item.orderID }} </b>
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 text-left pt-2>
                                      <router-link
                                        :to="
                                          '/productDetails/' +
                                          item.productId._id
                                        "
                                      >
                                        <span
                                          style="
                                            font-size: 16px;
                                            color: #808080;
                                          "
                                        >
                                          {{ item.name.slice(0, 25) }}
                                          <span v-if="item.name.length > 25">
                                            ...
                                          </span>
                                        </span>
                                      </router-link>
                                    </v-flex>
                                    <v-flex xs6 text-left>
                                      <span
                                        style="font-size: 14px; color: #000000"
                                      >
                                        Price: ₹{{ item.price }}
                                      </span>
                                    </v-flex>
                                    <v-flex xs6 text-right>
                                      <span
                                        style="font-size: 14px; color: #fa0000"
                                      >
                                        Discount: {{ item.discount }}%
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 text-left>
                                      <span
                                        style="font-size: 14px; color: #000000"
                                      >
                                        Offer Price: ₹{{ item.offerPrice }}
                                      </span>
                                    </v-flex>
                                    <v-flex xs12 text-left>
                                      <span
                                        v-if="
                                          (item.productOrderStatus = 'ordered')
                                        "
                                        style="font-size: 14px; color: #000000"
                                      >
                                        Ordered
                                      </span>

                                      <!-- <span
                              class="pl-5"
                              style="
                                font-family: opensanslight;
                                font-size: 12px;
                                color: #000000;
                              "
                            >
                              {{ formatDate(item.product.approved_at) }}
                            </span> -->
                                    </v-flex>
                                  </v-layout>
                                </v-flex>
                              </v-layout>
                            </v-flex>
                          </v-layout>
                        </v-card>
                      </v-flex>
                    </v-layout>
                    <v-layout wrap v-else justify-center pt-10>
                      <v-flex md12>
                        <h1>Oops!! No Orders found</h1>
                      </v-flex>
                    </v-layout>
                  </v-tab-item>
                </v-tabs>
                <v-row
                  class="justify-center pt-4"
                  v-if="seller.status != 'incomplete'"
                >
                  <span class="px-2">
                    <template>
                      <v-dialog v-model="rejectdialog" max-width="600px">
                        <template v-slot:activator="{ on, attrs }">
                          <v-btn v-on="on" v-bind="attrs" outlined color="red"
                            >Reject Seller</v-btn
                          >
                        </template>
                        <v-card>
                          <v-card-title class="headline grey lighten-2">
                            Delete Confirmation
                          </v-card-title>

                          <v-card-text style="padding-bottom: 0px">
                            <v-col cols="12">
                              <span style="font-size: 16px; font-weight: 600"
                                >Please confirm that you want to Remove this
                                Seller?
                              </span>
                              <v-text-field
                                outlined
                                dense
                                v-model="remark"
                                label="Remark"
                              >
                              </v-text-field>
                            </v-col>
                          </v-card-text>
                          <v-divider></v-divider>
                          <v-card-actions>
                            <v-spacer></v-spacer>
                            <v-btn color="error" @click="rejectdialog = false"
                              >Cancel</v-btn
                            >
                            <v-btn color="primary" @click="rejectSeller()"
                              >Reject</v-btn
                            >
                          </v-card-actions>
                        </v-card>
                      </v-dialog>
                    </template>
                  </span>

                  <span v-if="seller.status == 'pending'">
                    <v-btn outlined color="primary" @click="approveSeller()"
                      >Approve Seller</v-btn
                    >
                  </span>
                </v-row>
              </v-card>
            </v-flex>
          </v-layout>
        </v-form>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
//import store from "../../store";
import axios from "axios";
import Map from "./map";
export default {
  components: {
    Map,
  },
  data() {
    return {
      valid: true,
      companyRules: [
        (v) => !!v || "Company Name is required",
        (v) =>
          (v && v.length <= 50) ||
          "Company Name must be less than 50 characters",
      ],
      numberrules: [
        // (v) => !isNaN(parseFloat(v)) || "Number is Expected",
        (v) => v >= 0 || "Number is Expected",
      ],

      emailRules: [
        (v) => !!v || "E-mail is required",
        (v) => /.+@.+\..+/.test(v) || "E-mail must be valid",
      ],
      phoneRules: [(v) => !!v || "Phone is required"],
      datatab: null,
      seller: {
        sellerid: {
          bankDetails: {},
        },
      },
      category: [],
      dialog: false,
      subcategory: [],
      products: [],
      productsold: [],
      remark: null,
      rejectdialog: false,
      showsnackbar: false,
      msg: null,
      ServerError: false,
      validateInput: null,
      timeout: 5000,
      appLoading: false,
      coverphoto: null,
      profilepic: null,
      documents: null,
      photos: [],
      docs: [],
      workingHours: null,
    };
  },

  beforeMount() {
    this.getSeller();
    this.getProducts();
  },
  methods: {
    nextPage() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/customer/previous/next",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          customerid: this.$route.params.id,
          type: "previous",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/Customer/" + response.data.data._id);
            this.getCustomer();
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    prevPage() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/customer/previous/next",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          customerid: this.$route.params.id,
          type: "next",
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.$router.push("/Customer/" + response.data.data._id);
            this.getCustomer();
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },

    getSeller() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/user/view/" + this.$route.params.id,
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.seller = response.data.data;
            if (this.seller.sellerid) {
              this.coverphoto = this.seller.sellerid.coverPhoto;
              this.profilepic = this.seller.sellerid.photo;
              this.documents = this.seller.sellerid.documents;

              for (var i = 0; i < this.documents.length; i++) {
                if (
                  this.getFile_ext(this.documents[i]) == "jpg" ||
                  this.getFile_ext(this.documents[i]) == "png" ||
                  this.getFile_ext(this.documents[i]) == "jpeg"
                )
                  this.photos.push(this.documents[i]);
                else this.docs.push(this.documents[i]);
              }

              this.workingHours = this.seller.sellerid.workingHour;
            }

            if (this.seller.sellerid) {
              this.category = this.seller.sellerid.category;
              this.subcategory = this.seller.sellerid.subcategory;
            } else {
              this.seller.sellerid = {};
              this.seller.sellerid.bankDetails = {};
            }
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    getProducts() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/product/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          userid: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.products = response.data.data;
            // console.log(this.products);
            this.getPurchases();
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },

    getPurchases() {
      this.appLoading = true;
      axios({
        method: "POST",
        url: "/admin/seller/ordered/products/list",
        headers: {
          token: localStorage.getItem("token"),
        },
        data: {
          sellerId: this.$route.params.id,
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.productsold = response.data.data;
          }
        })
        .catch((err) => {
          this.ServerError = true;
          console.log(err);
        });
    },
    approveSeller() {
      axios({
        url: "/user/approve",
        method: "POST",
        data: {
          id: this.$route.params.id,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Seller Approval Complete!";
            this.$$router(-1);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    rejectSeller() {
      this.rejectdialog = false;

      axios({
        url: "/user/reject",
        method: "POST",
        data: {
          id: this.$route.params.id,
          remark: this.remark,
        },
        headers: {
          token: localStorage.getItem("token"),
        },
      })
        .then((response) => {
          this.appLoading = false;
          if (response.data.status) {
            this.msg = "Category Deleted";
            // this.showsnackbar = true;
            this.$router.go(-1);
          } else {
            this.msg = response.data.msg;
            this.showsnackbar = true;
          }
        })
        .catch((err) => {
          this.appLoading = false;
          this.ServerError = true;
          console.log(err);
        });
    },

    formatDate(oldDate) {
      if (oldDate) {
        var newdateFormat = oldDate.split("T");
        var splitDate = newdateFormat[0].split("-");
        if (splitDate.count == 0) {
          return null;
        }

        var year = splitDate[0];
        var month = splitDate[1];
        var day = splitDate[2];

        return day + "/" + month + "/" + year;
      }
    },

    // getFile_ext(filename) {
    //   if (filename) {
    //     var [name, extension] = filename
    //       .split(".")
    //       .reduce(
    //         (acc, val, i, arr) =>
    //           i == arr.length - 1
    //             ? [acc[0].substring(1), val]
    //             : [[acc[0], val].join(".")],
    //         []
    //       );
    //     console.log(name + " " + extension);
    //     var ext = extension;
    //     return ext;
    //   }
    // },
    getFile_ext(filename) {
      var ext;
      ext = filename.slice(
        (Math.max(0, filename.lastIndexOf(".")) || Infinity) + 1
      );
      return ext;
    },
  },
};
</script>

<style >
.item_title {
  font-weight: bold;
  font-size: 14px;
}
.item_value {
  font-size: 13px;
  color: Black;
}
.v-card__title {
  line-height: 1rem !important;
}
.titlestyle {
  padding-bottom: 0px !important;
}
a {
  text-decoration: none !important;
}
</style>